import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MasterUsersProfileService } from './master-create-profile-users.service';
import { uniqBy } from 'lodash';

@Component({
  selector: 'app-master-create-profile-users',
  templateUrl: './master-create-profile-users.component.html',
  styleUrls: ['./master-create-profile-users.component.scss'],
})
export class MasterCreateProfileUsersComponent implements OnInit {
  users: any;
  filterAutoComplete: any;
  userFilter: any;
  clientStatus = true;
  usersSelected: string[] = [];

  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();
  constructor(private serviceUserProfileEdit: MasterUsersProfileService) {}

  ngOnInit() {
    this.getProfiles();
  }

  async getProfiles() {
    this.users = await this.serviceUserProfileEdit.getUsersAll();
  }

  checkDuplicateValues() {
    this.usersSelected = uniqBy(this.usersSelected, 'id');
  }

  checkDataTable(e) {
    e.map(ele => {
      this.usersSelected.push(ele);
    });
    this.checkDuplicateValues();
  }
}
